module.exports = __webpack_public_path__ + "static/media/compass-icon.b4525a51.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/footer/compass-icon.svg
// module id = 344
// module chunks = 0 1 2